/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Voice_Ph_Ma_Don_Noi_Bo_ExInputs */

const vi_station_voice_ph_ma_don_noi_bo_ex = /** @type {(inputs: Station_Voice_Ph_Ma_Don_Noi_Bo_ExInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A45 đọc thành A bốn năm`)
};

/**

* @param {Station_Voice_Ph_Ma_Don_Noi_Bo_ExInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_voice_ph_ma_don_noi_bo_ex = /** @type {((inputs?: Station_Voice_Ph_Ma_Don_Noi_Bo_ExInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Voice_Ph_Ma_Don_Noi_Bo_ExInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_voice_ph_ma_don_noi_bo_ex(inputs)
});